<template>
  <div>
    <el-row>
      <el-col class="pb-1.5">{{ title }}</el-col>
      <el-col>
        <div class="form-group !w-full">
          <el-select v-model="field.question_type" class="w-full">
            <el-option :value="'YES_OR_NO'" label="Yes Or No"></el-option>
            <el-option :value="'MCQ'" label="MCQ"></el-option>
            <el-option :value="'TEXT'" label="TEXT"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: ['field', 'title'],
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style lang="scss"></style>
